import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()

export class ManageTablesServices {

    backendUrl: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;

    api = "/managetables/"

    constructor(private http: AuthHttp) {
        // this.backendUrl = environment.url;
        this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
        this.secret = environment.secret;
    }

    getAllBranchesByRestaurant(id:any,br_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}get-allbranches-restaurant/${id}/${br_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallTableUsersByRestaurant(id:any,br_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}get-alltableusers-restaurant/${id}/${br_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    updateTableUsersStatusById(data) {
        return this.http.post(`${this.backendUrl}${this.api}update-alltableusers-status/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    deleteTableUsersConfigurationById(data) {
        return this.http.post(`${this.backendUrl}${this.api}delete-alltableusers-id/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    diningAreaFetch(data) {
        return this.http.post(`${this.backendUrl}/db/onlineorder/v1/dining-area-fetch` ,data, this.getHeaders()).map((response: Response) => response.json());
    }

    diningAreaCreate(data) {
        return this.http.post(`${this.backendUrl}/db/onlineorder/v1/dining-area-create` , data, this.getHeaders()).map((response: Response) => response.json());
    }

    getallTableUsersConfigurationBytableId(id:any,br_id:any) {
        return this.http.get(`${this.backendUrl}${this.api}get-alltableconfig-tableId/${id}/${br_id}` , this.jwt_new()).map((response: Response) => response.json());
    }

    AddUpdateTableUserConfiguration(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-update-tableConfig/` ,data , this.jwt_new()).map((response: Response) => response.json());
    }

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private getHeaders() {
        
        let headerVal = new Headers({ 'Content-Type': 'application/json' });
        headerVal.append('Authorization', environment.authorization_key)
        headerVal.append('uuid', environment.uuid)
        let optionVal = new RequestOptions({ headers: headerVal });
        return optionVal;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/managetables.service.ts